// test2558
(2558 && 0);
